<template>
  <div class="n-input n-readonly-input">
    <n-split-input-button
      :label="label"
      :hideLabel="hideLabel"
      :helpText="helpText"
      :id="inputId"
      :value="readonlyValue"
    >
      <template v-slot:input>
        <n-text-input class="n-readonly-input__input" v-model="readonlyValue" :id="inputId" :disabled="true" />
      </template>
      <template v-slot:button>
        <n-button icon="copy" variant="split" class="n-readonly-input__button" @click="copyValue"> </n-button>
      </template>
    </n-split-input-button>
  </div>
</template>

<script lang="ts" setup>
import { watch, ref } from 'vue';
import { useClipboard } from '@vueuse/core';
import NButton from '../../control/button/button.vue';
import NSplitInputButton from '../split-input-button/split-input-button.vue';
import NTextInput from '../text-input/text-input.vue';
import { useIdGenerator } from '@/shared/designsystem/useIdGenerator';

defineOptions({
  name: 'n-readonly-input',
});

const props = defineProps({
  id: {
    type: String,
    default: () => '',
  },
  label: {
    type: String,
    required: true,
  },
  value: {
    type: String,
    required: true,
  },
  helpText: {
    type: String,
  },
  hideLabel: {
    type: Boolean,
    default: false,
  },
});

const { inputId } = useIdGenerator(props.id);

const readonlyValue = ref('');
const { copy } = useClipboard();

watch(
  () => props.value,
  () => (readonlyValue.value = props.value),
  { immediate: true },
);

const emit = defineEmits<{
  (e: 'copy'): void;
}>();

async function copyValue() {
  await copy(readonlyValue.value);
  emit('copy');
}
</script>
